import React, { useState } from 'react';
import StepLayout from '../components/StepLayout';
import SelectionCard from '../components/SelectionCard';
import { api } from '../api';

// iter-26: rebuild per ID Type Selection Page UI Spec.
//   Heading      — "What ID do you have? *"
//   Subtitle     — "Tick all that apply"
//   Amber callout — "Your ID must be in date. Expired documents won't
//                    be accepted." with left-border 4px #BA7517
//   Cards         — multi-select via shared SelectionCard (orange)
//   Next         — disabled until at least one card is selected
//   Trustpilot   — kept (standard component, mounted by StepLayout)
const OPTIONS = [
  { value: 'Passport', label: 'Passport' },
  { value: 'Driving License', label: 'Driving License' },
];

export default function Step11IDType({ sessionId, sessionData, updateData, onNext }) {
  const initial = Array.isArray(sessionData.idTypes) ? sessionData.idTypes : [];
  const [selected, setSelected] = useState(initial);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [submitError, setSubmitError] = useState('');

  const toggle = (val) => {
    setSelected((prev) => prev.includes(val) ? prev.filter((x) => x !== val) : [...prev, val]);
    if (error) setError('');
  };

  const handleNext = async () => {
    if (selected.length === 0) {
      setError('Please select at least one ID type.');
      return;
    }
    setError('');
    setLoading(true);
    setSubmitError('');
    try {
      await api.updateIdTypes(sessionId, { idTypes: selected });
      updateData({ idTypes: selected });
      onNext();
    } catch (err) {
      setSubmitError(err.message || 'Failed to save.');
    } finally {
      setLoading(false);
    }
  };

  const canSubmit = selected.length > 0 && !loading;

  return (
    <StepLayout title="What ID do you have? *">
      <p style={{
        fontFamily: 'var(--font-sans)',
        fontSize: 15,
        color: '#666',
        margin: '0 0 20px',
      }}>
        Tick all that apply
      </p>

      <div className="amber-callout" role="note">
        <span className="amber-callout__icon" aria-hidden="true">&#9201;</span>
        <span className="amber-callout__text">
          Your ID must be <strong>in date</strong>. Expired documents won&rsquo;t be accepted.
        </span>
      </div>

      <div
        role="group"
        aria-label="ID types"
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 12,
          marginBottom: 32,
        }}
      >
        {OPTIONS.map((opt) => (
          <SelectionCard
            key={opt.value}
            id={`idtype-${opt.value.replace(/\s+/g, '-').toLowerCase()}`}
            name="idTypes"
            value={opt.value}
            label={opt.label}
            selected={selected.includes(opt.value)}
            multi
            onSelect={toggle}
            disabled={loading}
          />
        ))}
      </div>

      {error && <p className="form-field__error">{error}</p>}
      {submitError && <p className="form-field__error">{submitError}</p>}

      <div className="cta-row">
        <button
          type="button"
          onClick={handleNext}
          disabled={!canSubmit}
          aria-disabled={!canSubmit}
          className="cta-row__btn primary-cta"
        >
          {loading ? 'Saving...' : 'Next'}
        </button>
      </div>
    </StepLayout>
  );
}
